import { toast } from "sonner";

const NUMBER = (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/\D/g, "");
const TEXT = encodeURIComponent("Hi LuxeRay, I'd like to know more about smart home / AIoT automation.");

/** Floating WhatsApp CTA. Number comes from REACT_APP_WHATSAPP_NUMBER (digits, with country code). */
export default function WhatsAppButton() {
  const onClick = (e) => {
    if (NUMBER) return; // real wa.me link opens in a new tab
    e.preventDefault();
    toast.info("WhatsApp line is being connected", { description: "Use the enquiry form and we'll call you back." });
    document.getElementById("enquiry")?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <a
      href={NUMBER ? `https://wa.me/${NUMBER}?text=${TEXT}` : "#enquiry"}
      target={NUMBER ? "_blank" : undefined}
      rel="noopener noreferrer"
      onClick={onClick}
      aria-label="Chat with LuxeRay sales on WhatsApp"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2.5 pl-3 pr-4 py-2.5 rounded-full bg-[#061536]/95 border border-white/15 text-white shadow-xl shadow-black/50 hover:border-[#25D366]/60 hover:-translate-y-0.5 transition-[transform,border-color]"
      data-testid="whatsapp-fab"
      data-live={NUMBER ? "true" : "false"}
    >
      <span className="w-8 h-8 rounded-full bg-[#25D366] flex items-center justify-center shrink-0">
        <svg viewBox="0 0 24 24" className="w-5 h-5 fill-white" aria-hidden="true">
          <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.14-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.91-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35M12.05 21.78h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.9-9.88 2.64 0 5.12 1.03 6.99 2.9a9.82 9.82 0 0 1 2.89 6.99c0 5.45-4.44 9.88-9.89 9.88m8.41-18.3A11.82 11.82 0 0 0 12.05 0C5.5 0 .16 5.33.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.9 11.9 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.33 11.89-11.89 0-3.18-1.24-6.16-3.48-8.41" />
        </svg>
      </span>
      <span className="font-mono-lbl text-[11px] uppercase tracking-wider">WhatsApp Sales</span>
    </a>
  );
}
